import React from 'react';

import PropTypes from 'prop-types';

import { InfoHeroBlock } from './styles';
import { REGISTRATION } from '../../../constants/UrlConstants';
import { LightDiskBadge } from '../common/fromAuth/LightDiskBadge/LightDiskBadge';
import { LightNavBar } from '../common/fromAuth/LightNavBar/LightNavBar';
import { PromoButton } from '../common/promo-button/PromoButton';
import { PromoText } from '../common/promo-text/PromoText';
import { PromoRow } from '../common/PromoRow/PromoRow';
import { PromoSectionContainer } from '../common/PromoSectionContainer';
import LogoPurple from '../header-fixed/LogoPurple';

const ReqAndMoneyInfo = (props) => {
    const { extra } = props;
    const { avatar, country_code, headerText, currencyCode, comment, formatedAmount, promo_text, continueWeb, downloadLink, getApp, fromFi } = extra;
    const firstLetter = extra.fromName[0];

    return (
        <>
            <LightNavBar align="left">
                <LogoPurple whiteColor />
            </LightNavBar>
            <InfoHeroBlock>
                <PromoSectionContainer>
                    <PromoRow textAlign={'center'} indent={'32px'}>
                        <LightDiskBadge src={avatar ? avatar : null} diskText={!avatar ? firstLetter : null} flagName={country_code} diskSize={'x-large'} />
                    </PromoRow>
                    <PromoRow indent={'32px'}>
                        <PromoRow indent={'4px'}>
                            <PromoText tag={'div'} variant={'subheader'} color={'white'} textAlign={'center'}>
                                {`${headerText} ${fromFi}`}
                            </PromoText>
                        </PromoRow>
                        <PromoRow indent={'8px'}>
                            <PromoText tag={'div'} variant={'h1'} color={'white'} textAlign={'center'}>
                                {formatedAmount + ' '}
                                <PromoText tag={'span'} variant={'h1'} color={'white'} smallCaps>
                                    {currencyCode.toLowerCase()}
                                </PromoText>
                            </PromoText>
                        </PromoRow>
                    </PromoRow>
                    {comment && (
                        <PromoRow indent={'32px'}>
                            <PromoText tag={'div'} variant={'subheader'} color={'whiteRgba48'} textAlign={'center'}>
                                {comment}
                            </PromoText>
                        </PromoRow>
                    )}
                    <PromoRow indent={'56px'}>
                        <PromoText tag={'div'} variant={'subheader'} color={'white'} textAlign={'center'}>
                            {promo_text}
                        </PromoText>
                    </PromoRow>
                    <PromoRow textAlign={'center'} indent={'16px'}>
                        <PromoButton variant={'primary'} isInverted type="link" href={downloadLink} caption={getApp} target="_blank" />
                    </PromoRow>
                    <PromoRow textAlign={'center'}>
                        <PromoButton variant={'tertiary'} isInverted type="link" caption={continueWeb} href={REGISTRATION} />
                    </PromoRow>
                </PromoSectionContainer>
            </InfoHeroBlock>
        </>
    );
};

ReqAndMoneyInfo.propTypes = {
    extra: PropTypes.object.isRequired,
};

export default ReqAndMoneyInfo;
